import React from 'react';
import { CLASSNAME_PREFIX } from '../../componentConfig';
import './TimeOutResult.scss';
import { GamblingHelpSection } from '../GamblingHelpSection';
import SuccessTick from '@wh/svg-icons/Tick';

export var TimeOutResult = function TimeOutResult(_ref) {
  var translate = _ref.translate,
      period = _ref.period,
      countryCode = _ref.countryCode,
      gamblingHelpConfig = _ref.gamblingHelpConfig;
  return React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-time-out-result__wrapper' },
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-time-out-result__content' },
      React.createElement(
        'div',
        { className: CLASSNAME_PREFIX + '-time-out-result__icon' },
        React.createElement(SuccessTick, { className: CLASSNAME_PREFIX + '-time-out-result__svg' })
      ),
      React.createElement(
        'h3',
        { className: CLASSNAME_PREFIX + '-time-out-result__title' },
        translate('saferGambling.views.timeOut.resultPage.title')
      ),
      React.createElement(
        'h4',
        { className: CLASSNAME_PREFIX + '-time-out-result__information' },
        translate('saferGambling.views.timeOut.resultPage.information', { period: period })
      )
    ),
    React.createElement(GamblingHelpSection, {
      mainText: translate('saferGambling.views.timeOut.resultPage.helpSectionMainText'),
      countryCode: countryCode,
      config: gamblingHelpConfig
    })
  );
};